function PageFallback() {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-6 text-sm text-slate-500 dark:border-zinc-800 dark:bg-zinc-900 dark:text-slate-400">
      Загрузка...
    </div>
  )
}

export default PageFallback

